import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MistService } from '@app/features/mists/shared/mist.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RogueAccessPoint } from '@app/shared/models/mist/rogue-ap.model';

@Component({
    selector: 'app-mist-rogue-ap-audit',
    templateUrl: './rogue-ap-audit.component.html',
    styleUrls: ['./rogue-ap-audit.component.css'],
    standalone: false
})
export class RogueAccessPointsComponent implements OnInit {
    @ViewChild('rogueApTable') mistsTable: MatTable<RogueAccessPoint>;
    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    isLoading = false;
    filterText: string = null;
    rogueAccessPoints = [];
    displayedColumns = ['storeNumber', 'mac', 'ssid', 'rssi', 'channel'];
    dataSource = new MatTableDataSource<RogueAccessPoint>(this.rogueAccessPoints);

    constructor(private mistsService: MistService) { }

    ngOnInit() {
        this.isLoading = true;
        Promise.all(
            [
                this.getRogueAccessPointAudit()
            ]
        ).then(() => {
            this.dataSource.paginator = this.paginator;
            this.dataSource.sortingDataAccessor = (item, property) => {
                switch (property) {
                    case 'storeNumber': return item.storeNumber;
                    case 'mac': return item.mac;
                    case 'ssid': return item.ssid;
                    case 'rssi': return item.rssi;
                    case 'channel': return item.channel;
                    default: return item[property];
                }
            };
            this.dataSource.sort = this.sort;
            this.mistsTable.renderRows();
            this.isLoading = false;
        });
    }

    getRogueAccessPointAudit() {
        const promise = new Promise((resolve) => {
            this.mistsService.getRogueAccessPointAudit().then(response => {
                response.toPromise().then(audit_from_response => {
                    try {
                        for (let storeNumber in audit_from_response["message"]) {
                            for (let key in audit_from_response["message"][storeNumber]["results"]) {
                                let rogue_ap: RogueAccessPoint = new RogueAccessPoint;
                                rogue_ap.storeNumber = storeNumber;
                                rogue_ap.mac = audit_from_response["message"][storeNumber]["results"][key]["ap_mac"];
                                rogue_ap.rssi = audit_from_response["message"][storeNumber]["results"][key]["avg_rssi"];
                                rogue_ap.ssid = audit_from_response["message"][storeNumber]["results"][key]["ssid"];
                                rogue_ap.channel = audit_from_response["message"][storeNumber]["results"][key]["channel"];
                                this.rogueAccessPoints.push(rogue_ap);
                            }
                        }
                    } catch (error) {
                        console.log("Audit timed out!")
                    } finally {
                        resolve(true);
                    }
                });
            });
        });
        return promise;
    }
}